import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './models/autocomplete-chips.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

// Apply styles to autocomplete chips using MutationObserver to catch dynamically added chips
const applyChipStyles = () => {
  const styleChips = () => {
    // Find all chips that are deletable
    const chips = document.querySelectorAll('.MuiChip-root.MuiChip-deletable');
    chips.forEach(chip => {
      // Check if chip is within an AutocompleteArrayInput container
      // Look for parent with RaAutocompleteArrayInput class
      const container = chip.closest('[class*="RaAutocompleteArrayInput"]');
      
      // Also check if parent form control has an input field (AutocompleteArrayInput has an input)
      const formControl = chip.closest('.MuiFormControl-root');
      const hasInputParent = formControl && formControl.querySelector('input[type="text"]');
      
      // Apply styles if chip is in an AutocompleteArrayInput container or in a form control with an input
      // (AutocompleteArrayInput renders chips in a form control with an input field)
      if (container || hasInputParent) {
        // Only apply if not already styled (check for data attribute)
        if (!chip.dataset.chipStyled) {
          chip.style.backgroundColor = '#000000';
          chip.style.color = '#ffffff';
          chip.dataset.chipStyled = 'true';
          
          // Style the delete icon
          const deleteIcon = chip.querySelector('.MuiChip-deleteIcon');
          if (deleteIcon) {
            deleteIcon.style.color = '#ffffff';
          }
        }
      }
    });
  };

  // Apply styles immediately
  styleChips();

  // Watch for new chips being added to the DOM
  const observer = new MutationObserver(() => {
    styleChips();
  });

  // Start observing the document body for changes
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Also inject CSS as fallback
  const styleId = 'autocomplete-chips-inline-styles';
  if (!document.getElementById(styleId)) {
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      /* AutocompleteArrayInput chip styles */
      [class*="RaAutocompleteArrayInput"] .MuiChip-root.MuiChip-deletable {
        background-color: #000000 !important;
        color: #ffffff !important;
      }
      [class*="RaAutocompleteArrayInput"] .MuiChip-root.MuiChip-deletable .MuiChip-deleteIcon {
        color: #ffffff !important;
      }
    `;
    document.head.appendChild(style);
  }
};

ReactDOM.render(<App />, document.getElementById('root'));

// Apply styles after React has rendered
// Use setTimeout to ensure React has finished rendering
setTimeout(() => {
  applyChipStyles();
}, 100);

// Also apply on DOMContentLoaded as fallback
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', applyChipStyles);
} else {
  applyChipStyles();
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
